import React from 'react';
import { IconUser } from '@tabler/icons-react';

import DefaultAvatar from './DefaultAvatar';
import SafeImage from './SafeImage';
import { profileAvatarSrc } from '../lib/profileAvatarSrc';

/**
 * Circular profile avatar — fixed size, overflow clip, image or initial/emoji fallback.
 */
function UserAvatar({ src, name = 'Mingo', size = 40, className = '', emoji, fallbackEmoji = null }) {
  const resolved = src ? profileAvatarSrc(src) : '';
  const fallbackNode = fallbackEmoji ?? <IconUser size={Math.max(14, Math.round(size * 0.45))} stroke={1.75} aria-hidden />;

  return (
    <span
      className={`mingo-user-avatar ${className}`.trim()}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {resolved ? (
        <SafeImage
          src={resolved}
          alt=""
          width={size}
          height={size}
          className="mingo-user-avatar__img"
          fallbackEmoji={fallbackNode}
        />
      ) : (
        <DefaultAvatar name={name} size={size} emoji={emoji} className="mingo-user-avatar__img" />
      )}
    </span>
  );
}

export default React.memo(UserAvatar);
